import api from "./base-api"

const rogerthatPrefabApiV2 = api.injectEndpoints({
    endpoints: (build) => ({
        getPrefabV2RT: build.query({
            query: (id = "") => `v2/rogerthat/prefabs/${id}`,
            providesTags: (result, error, arg) => {
                return result
                    ? [{type: 'PrefabItem', id:result.id}, 'PrefabItem']
                    : ['PrefabItem']
            }
        }),
        getPrefabsInfosV2RT: build.query({
            query: (id = "") => `v2/rogerthat/prefabs/infos`,
            transformResponse(data) {
                return data.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0))
            },
            providesTags: ['PrefabsRT']
        }),
        getPrefabsListV2RT: build.query({
            query: (id = "") => `v2/rogerthat/prefabs`,
            transformResponse(data) {
                return data.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0))
            },
            providesTags: ['PrefabsRT']
        }),
        createPrefabV2RT: build.mutation({
            query: (body = {}) => ({
                url: "v2/rogerthat/prefabs",
                method: "POST",
                body: body.data,
                env: body.env
            }),
            invalidatesTags: ['PrefabsRT']

        }),
        deletePrefabV2RT: build.mutation({
            query: (id = "") => ({
                url: `v2/rogerthat/prefabs/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ['PrefabsRT']

        }),
        updatePrefabV2RT: build.mutation({
            query: (data = {}) => ({
                url: `v2/rogerthat/prefabs/${data.id}`,
                method: "PUT",
                body: data.body
            }),
            invalidatesTags: ['PrefabItem']

        })
    }),
    overrideExisting: false
})

export const {
    useGetPrefabV2RTQuery,
    useGetPrefabsInfosV2RTQuery,
    useGetPrefabsListV2RTQuery,
    useCreatePrefabV2RTMutation,
    useDeletePrefabV2RTMutation,
    useUpdatePrefabV2RTMutation
} = rogerthatPrefabApiV2
